export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'job-summary',
    title: '職務要約',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'skills-to-use',
    title: 'スキル',
    // previewJumpId: 'preview-page-02'
    previewJumpId: 'skills'
  },
  {
    id: 'job-history',
    title: '職務経歴',
    previewJumpId: 'job-history'
  },
  {
    id: 'pr-message',
    title: '自己PR',
    previewJumpId: 'pr-message'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'preview-page-01'
  }
]
